import { PRESSURE_UNIT, RAIN_UNIT, SPEED_UNIT } from './constants';

export const getLowestMaxWindAxisValue = speedUnit => {
	switch (speedUnit) {
		case SPEED_UNIT.KNOTS:
			return 20;
		case SPEED_UNIT.MPH:
			return 25;
		case SPEED_UNIT.MS:
			return 10;
		case SPEED_UNIT.KMH:
			return 40;
	}
};

export const getWindAxisStepOptions = speedUnit => {
	switch (speedUnit) {
		case SPEED_UNIT.KNOTS:
			return [5, 10, 15, 20];
		case SPEED_UNIT.MPH:
			return [5, 10, 15, 20];
		case SPEED_UNIT.MS:
			return [2, 5, 10];
		case SPEED_UNIT.KMH:
			return [10, 15, 20, 25, 30];
	}
};

export const getLowestMaxRainAxisValue = rainUnit => {
	return rainUnit === RAIN_UNIT.IN ? 0.2 : 3;
};

export const getRainAxisStepOptions = rainUnit => {
	return rainUnit === RAIN_UNIT.IN
		? [0.1, 0.2, 0.25, 0.5, 1, 2, 4]
		: [1, 2, 5, 10, 20, 25, 50, 100];
};

export const getPressureAxisStepOptions = pressureUnit => {
	return pressureUnit === PRESSURE_UNIT.INHG
		? [0.1, 0.2, 0.25, 0.5, 1]
		: [1, 2, 3, 4, 5, 10, 20];
};



// WEBPACK FOOTER //
// ./utils/graph-limits.js